import { RouteProps } from "react-router-dom";

import { RouteOptions } from "@/lib/types";
import { PageNotFound } from "@/pages/404/PageNotFound";
import { GUEST_ROUTE, MEMBER_ROUTE as PRIVATEROUTES } from "../lib/constants";
import { Layout as DefaultLayout } from "@/layouts/Default";
import { CurrencyManagement } from "@/pages/currency/CurrencyManagement";
import { DashboardLandingPage } from "@/pages/dashboard/DashboardLandingPage";
import { DashboardView } from "@/pages/dashboard/DashboardView";
import { Login } from "@/pages/login/Login";
import { Requests } from "@/pages/requests/Requests";
import { Transactions } from "@/pages/transactions/TransactionsPage";
import { Wallets } from "@/pages/wallet/Wallets";

export const privateRoutes = (_options?: RouteOptions): RouteProps[] => [
	{
		path: PRIVATEROUTES.GET_STARTED,
		element: <DashboardLandingPage />,
	},
	{
		path: PRIVATEROUTES.DASHBOARD,
		element: <DashboardView />,
	},
	{
		path: PRIVATEROUTES.REQUESTS,
		element: <Requests />,
	},
	{
		path: PRIVATEROUTES.WALLETS,
		element: <Wallets  />,
	},
	{
		path: PRIVATEROUTES.TRANSACTIONS,
		element: <Transactions />,
	},
	{
		path: PRIVATEROUTES.CURRENCY_MANAGEMENT,
		element: <CurrencyManagement />,
	},
	{
		path: PRIVATEROUTES.CURRENCY_MANAGEMENT,
		element: <DashboardLandingPage />,
	},
];

export const guestRoutes: RouteProps[] = [
	{
		path: GUEST_ROUTE.LOGIN,
		element: <Login />,
	},
	{
		path: GUEST_ROUTE.PAGE_NOT_FOUND,
		element: <PageNotFound />,
	},
];

export const centralBankRoutes: RouteProps[] = [
	{
		path: PRIVATEROUTES.HOME,
		element: <DefaultLayout />,
	},
];

export const integratorRoutes: RouteProps[] = [
	{
		path: PRIVATEROUTES.HOME,
		element: <DefaultLayout />,
	},
];

export const commonRoutes: RouteProps[] = [
	{
		path: "*",
		element: <PageNotFound />,
	},
];
